import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín L., 42',
    city: 'Pergamino',
    text: 'Doy clases de producción forestal hace 8 años y siempre perdía horas buscando material técnico actualizado. Este kit me cambió todo. Ahora entro al aula con cada clase armada y mis alumnos notan la diferencia.',
    role: 'Profesor de producción forestal'
  }, {
    name: 'Carolina S., 35',
    city: 'Rosario',
    text: 'Enseñar viveros y plantación era un desafío porque no había material estructurado. Con este sistema tengo todo organizado por tomo y las actividades prácticas son excelentes.',
    role: 'Docente de ciencias forestales'
  }, {
    name: 'Jorge R., 50',
    city: 'Córdoba',
    text: 'El tomo de aprovechamiento de madera está impecable. Lo uso para capacitar técnicos forestales y la estructura es perfecta para llevar la teoría al campo.',
    role: 'Instructor forestal'
  }, {
    name: 'Lucía M., 38',
    city: 'Mendoza',
    text: 'La planificación anual es oro puro. Antes improvisaba semana a semana, ahora tengo todo el año resuelto. Mis alumnos de la técnica agradecen las clases organizadas.',
    role: 'Profesora de gestión forestal'
  }, {
    name: 'Fernando P., 55',
    city: 'Entre Ríos',
    text: 'Compramos el sistema Pro para todos los docentes del área forestal de nuestra escuela. La calidad técnica y las evaluaciones listas nos ahorraron meses de trabajo.',
    role: 'Director de escuela agrotécnica'
  }];
  return <section className="bg-[#0B1F17] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-212">
          TESTIMONIOS DE DOCENTES
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3" data-id="element-213">
          {testimonials.map((t, i) => <div key={i} className="bg-[#102A1F] border border-[#1F3D2B] p-3 rounded-lg flex flex-col shadow-lg" data-id="element-214">
              <div className="text-[#D4A843] text-xs mb-1.5 tracking-widest" data-id="element-215">
                ★★★★★
              </div>
              <p className="text-[#BFC9C5] font-bold text-xs mb-3 flex-grow italic leading-snug" data-id="element-216">
                "{t.text}"
              </p>
              <div className="border-t border-[#1F3D2B] pt-2" data-id="element-217">
                <p className="font-black text-white text-xs uppercase" data-id="element-218">
                  {t.name}
                </p>
                <p className="text-[9px] md:text-[10px] font-bold text-[#74C69D] uppercase mt-0.5" data-id="element-219">
                  {t.role} • {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}